import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { IconDefinition } from '@ant-design/icons-angular';
import { NZ_ICONS } from 'ng-zorro-antd/icon';
import {
	ArrowLeftOutline,
	CalendarOutline,
	CaretDownOutline,
	CheckCircleOutline,
	ClockCircleOutline,
	CloseOutline,
	CloudDownloadOutline,
	EditOutline,
	EllipsisOutline,
	ExclamationCircleOutline,
	EyeOutline,
	FormOutline,
	LeftCircleOutline,
	LineOutline,
	LinkOutline,
	MenuFoldOutline,
	MenuOutline,
	MinusCircleOutline,
	PaperClipOutline,
	PlusCircleOutline,
	PlusOutline,
	QuestionCircleOutline,
	ReadOutline,
	RightCircleOutline,
	SearchOutline,
	UserOutline,
	LoginOutline,
	LogoutOutline,
	PauseOutline,
	PictureTwoTone,
    FileTwoTone,
    DownloadOutline,
    InboxOutline,
} from '@ant-design/icons-angular/icons';

const antDesignIcons: IconDefinition[] = [
	MenuFoldOutline, // Menu collapse
	MenuOutline, // Menu mobile toggle
	ArrowLeftOutline, // Back button
	LeftCircleOutline,
	RightCircleOutline,
	PlusCircleOutline,
	MinusCircleOutline, // Trees, Arrays
	FormOutline,
	UserOutline,
	PlusOutline, // Tables
	ReadOutline, // Placeholder
	LinkOutline, // Links
	CloudDownloadOutline, // Download
	LineOutline, // Registrations
	// All these are being imported regardless apparently
	CloseOutline,
	CaretDownOutline,
	CalendarOutline,
	ClockCircleOutline,
	ExclamationCircleOutline,
	QuestionCircleOutline,
	CheckCircleOutline,
	PaperClipOutline,
	EyeOutline,
	EditOutline,
	EllipsisOutline,
	SearchOutline,
	LoginOutline, // These 3 are for QR sign in
	LogoutOutline,
	PauseOutline,
	PictureTwoTone,
    FileTwoTone,
    DownloadOutline,
    InboxOutline,
];

@NgModule({
	imports: [CommonModule],
	providers: [{ provide: NZ_ICONS, useValue: antDesignIcons }],
})
export class AntDesignIconsModule {}
